const site = {
  title: 'Grimes',
  subtitle: 'Selling Out',
  aboutCollection: [
    `Selling Out is an online exhibition featuring the artwork of Grimes. Presented by Maccarone, Los Angeles, this is Grimes’ debut with the gallery. The retrospective-like presentation spans the last 10 years of her practice and includes: original drawings as well as digital prints, photographs and video.`,
    `Grimes is a project rooted in DIY production — an interdisciplinary endeavor derived from the self-taught artistry of its author, c Boucher. Boucher’s creation is titled Grimes, a persona and the imagined realm that she inhabits, spanning art, music, fashion, technology and film. The origin of Grimes recalls a sculptor’s process: actualizing a cerebral concept into physical reality, imagining raw material into being. Grimes takes form as a simulation combining gamer fantasy, anime and manga, science fiction, apocalyptic omens, and anachronistic fashion, among other genres.`,
    `Selling Out explores the notion of identity potential in the digital age: the ability to create, augment, and manifest ourselves outside of our biological limits. Boucher does so with WarNymph, a digital avatar executed in collaboration with her brother and artistic partner, Mac Boucher. `,
  ],
  infoImage: require('../images/info.png'),
  indexImage: require('../images/index.png'),
  headerLinks: [
    {
      label: 'MACCARONE',
      position: 'left',
      uri: 'http://maccarone.net/',
      isExternal: true
    },
    {
      label: 'Shop',
      position: 'right',
      uri: 'https://www.maccaroneshop.net/',
      isExternal: true
    },
    {
      label: 'Info',
      position: 'right',
      uri: '/info',
      isExternal: false
    }
  ],
}

export default site